<template>
  <div v-if="ready">
    <!-- <img src="@/assets/img/datitop.png" width="100%" alt="" /> -->
    <div class="timu">
      <div class="question_title">
        选择题【共{{ count }}题，本题{{ point }}分】
      </div>
      <div class="question_desin">{{ timu.strcount }}.{{ timu.name }}</div>
      <CheckboxGroup
        v-model="answer"
        style="margin-top: 0.5rem; font-size: 5rem"
      >
        <CellGroup>
          <Cell size="large" v-if="timu.Axuan">
            <Checkbox
              name="A"
              :v-model="answer.indexOf('A') > -1"
              :disabled="submitS"
              :checked-color="checkResult ? '#1989fa' : '#D6473B'"
              @click="boxClick"
              ><span class="sp">A.{{ timu.Axuan }}</span></Checkbox
            >
          </Cell>
          <Cell size="large" v-if="timu.Bxuan">
            <Checkbox
              name="B"
              :v-model="answer.indexOf('B') > -1"
              :disabled="submitS"
              :checked-color="checkResult ? '#1989fa' : '#D6473B'"
              @click="boxClick"
              ><span class="sp">B.{{ timu.Bxuan }}</span></Checkbox
            >
          </Cell>
          <Cell size="large" v-if="timu.Cxuan">
            <Checkbox
              name="C"
              :v-model="answer.indexOf('C') > -1"
              :disabled="submitS"
              :checked-color="checkResult ? '#1989fa' : '#D6473B'"
              @click="boxClick"
              ><span class="sp">C.{{ timu.Cxuan }}</span></Checkbox
            >
          </Cell>
          <Cell size="large" v-if="timu.Dxuan">
            <Checkbox
              name="D"
              :v-model="answer.indexOf('D') > -1"
              :disabled="submitS"
              :checked-color="checkResult ? '#1989fa' : '#D6473B'"
              @click="boxClick"
              ><span class="sp">D.{{ timu.Dxuan }}</span></Checkbox
            >
          </Cell>
        </CellGroup>
      </CheckboxGroup>
      <!-- <RadioGroup
        v-model="answer"
        style="margin-top: 0.5rem; font-size: 5rem"
        @change="radiochange"
      >
        <CellGroup>
          <Cell size="large">
            <Radio
              :checked-color="
                submitAanswer == 'A' && timu.daan !== 'A' ? '#D6473B' : ''
              "
              :class="submitAanswer == 'A' ? 'active' : ''"
              name="A"
              ><span class="sp">A.{{ timu.Axuan }}</span></Radio
            >
          </Cell>
          <Cell size="">
            <Radio
              :checked-color="
                submitAanswer == 'B' && timu.daan !== 'B' ? '#D6473B' : ''
              "
              :class="submitAanswer == 'B' ? 'active' : ''"
              name="B"
              ><span class="sp">B.{{ timu.Bxuan }}</span></Radio
            >
          </Cell>
          <Cell size="">
            <Radio
              :checked-color="
                submitAanswer == 'C' && timu.daan !== 'C' ? '#D6473B' : ''
              "
              :class="submitAanswer == 'C' ? 'active' : ''"
              name="C"
              ><span class="sp">C.{{ timu.Cxuan }}</span></Radio
            >
          </Cell>
          <Cell size="large">
            <Radio
              :checked-color="
                submitAanswer == 'D' && timu.daan !== 'D' ? '#D6473B' : ''
              "
              :class="submitAanswer == 'D' ? 'active' : ''"
              name="D"
              ><span class="sp">D.{{ timu.Dxuan }}</span></Radio
            >
          </Cell>
        </CellGroup>
      </RadioGroup> -->
      <div style="padding: 0.3rem" v-if="submitAanswer">
        {{ result ? "正确" : "错误" }}，正确答案为{{ timu.daan }}
      </div>
    </div>
    <div style="margin: 0 0.3rem; margin-top: 0.1rem">
      <Button
        :disabled="!!submitAanswer"
        color="#D7463A"
        round
        size="large"
        @click="dati"
        >确定</Button
      >
      <Button
        v-if="list.length > 1 && submitS"
        round
        size="large"
        style="margin-top: 0.2rem; color: #d7463a; background-color: #fcebeb"
        @click="next"
        >下一题</Button
      >
    </div>

    <Overlay :show="show">
      <div class="innerbox">
        <img
          width="50%"
          src="@/assets/img/top.png"
          alt=""
          style="margin-left: 25%"
        />
        <div class="jifen">
          恭喜获得<span class="number">{{ getpoint }}</span
          >积分
        </div>
        <div class="jifen" @click="$router.replace({ path: '/' })">
          返回首页
        </div>
        <img
          class="close"
          src="@/assets/img/close.png"
          alt=""
          @click="show = false"
        />
      </div>
    </Overlay>
  </div>
</template>

<script>
import {
  CellGroup,
  Cell,
  Button,
  Overlay,
  Checkbox,
  CheckboxGroup,
} from "vant";
import { getTodayAnswer, putAnswer } from "@api/answer";
export default {
  components: {
    CellGroup,
    Cell,
    Button,
    Overlay,
    Checkbox,
    CheckboxGroup,
  },
  data() {
    return {
      show: false,
      ready: false,
      answer: [],
      count: "", //题目数量
      list: [], //题目列表
      timu: {}, //当前题目
      submitAanswer: "",
      getpoint: 0,
      submitS: false,
      checkResult: true,
    };
  },
  created() {
    this.getdata();
  },
  computed: {
    result() {
      let that = this;
      let arr = that.answer.sort().toString();
      if (arr != that.timu.daan) {
        that.checkResult = false;
      }
      return arr == that.timu.daan ? true : false;
    },
  },
  methods: {
    boxClick(e) {
      console.log(e);
    },
    getdata() {
      getTodayAnswer()
        .then((res) => {
          this.list = res.data.list;

          this.timu = res.data.list[0];
          this.count = res.data.count;
          this.point = res.data.point;
          this.ready = true;
        })
        .catch((err) => {
          console.log(err);
          this.ready = true;
        });
    },
    /* radiochange(e) {
      if (this.submitAanswer) {
        this.answer = this.submitAanswer;
      }
    }, */
    next() {
      this.submitS = false;
      this.answer = [];
      this.submitAanswer = "";
      this.checkResult = true;
      this.getdata();
    },
    dati() {
      if (this.answer == "") {
        this.$dialog.error("请先选择答案");
      } else {
        putAnswer({
          id: this.timu.id,
          daan: this.answer,
        }).then((res) => {
          this.submitS = true;
          this.submitAanswer = this.answer;
          if (res.data.is == 1) {
            this.show = true;
            this.getpoint = res.data.point;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.timu {
  padding: 0.3rem;
}
.timu .question_title {
  font-size: 0.32rem;
  line-height: 0.6rem;
}
.timu .question_desin {
  margin-top: 0.3rem;
  font-size: 0.3rem;
  line-height: 0.46rem;
}
.van-radio {
  font-size: 0.3rem;
  padding: 0.15rem;
}
.van-nav-bar .van-icon {
  color: #333333;
  font-size: 0.4rem;
}
.active .sp {
  color: #d6473b;
}

.innerbox {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.jifen {
  margin-left: 10%;
  width: 80%;
  background-image: url("~@/assets/img/bot.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  line-height: 0.9rem;
  font-size: 0.5rem;
  font-weight: normal;
  font-size: 0.4rem;
  margin-top: 0.4rem;
}
.close {
  position: absolute;
  top: -0.8rem;
  right: 0;
  height: 0.8rem;
}
.bottom {
  height: 1rem;
  line-height: 1rem;
  position: fixed;
  width: 100%;
  text-align: center;
  bottom: 0;
  font-size: 0.4rem;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 99;
}
</style>
